<div class="page-container">
  <app-page-header
    title="Geofences"
    [primary]="{ label: 'Create Geofence', icon: 'pi pi-plus' }"
    (primaryActionClick)="displayCreateGeofenceDialog()"
  >
    <div header-actions>
      <p-iconfield>
        <p-inputicon class="pi pi-search" />
        <input
          class="large-field"
          type="text"
          pInputText
          placeholder="Search Geofences"
          [ngModel]="searchTerm()"
          (input)="onSearchInput($event)"
        />
      </p-iconfield>
    </div>
  </app-page-header>

  @if (loading()) {
    <app-geofence-loading></app-geofence-loading>
  }
  @if (!loading() && !error()) {
    <div class="geofence-cards-container">
      @for (gf of filteredGroupedGeofences(); track gf.name) {
        <app-geofence-card class="geofence-card" [geofence]="gf" (deleted)="loadData(currentPage() + 1, pageSize())" />
      }
    </div>

    <app-pagination
      [totalRecords]="totalRecords()"
      [currentPage]="currentPage()"
      [pageSize]="pageSize()"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
    />

    <div>
      <div class="geofence-cards-container empty">
        @if (!filteredGroupedGeofences().length) {
          <div class="empty-state">
            <div class="empty-content">
              <i class="pi pi-map empty-icon"></i>
              <h3>No geofences found</h3>
              <p>There are no geofences matching your current filters.</p>
              <p-button
                label="Clear Filters"
                icon="pi pi-filter-slash"
                severity="secondary"
                [disabled]="!searchTerm()"
              ></p-button>
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (error() && !loading()) {
    <div class="error-state">
      <div class="error-content">
        <i class="pi pi-exclamation-triangle error-icon"></i>
        <h3>Unable to load geofences</h3>
        <p>There was an error loading the geofences data. Please try again.</p>
        <p-button label="Retry" icon="pi pi-refresh" (onClick)="loadData()"></p-button>
      </div>
    </div>
  }
</div>
